import { apiFetch } from "../api.js";
import type {
  CreateHousingAssessmentInput,
  HousingAssessment,
  HousingAssessmentsListResponse,
  UpdateHousingAssessmentInput,
} from "./types.js";

export function listHousingAssessments(
  unitId: string,
): Promise<HousingAssessmentsListResponse> {
  return apiFetch<HousingAssessmentsListResponse>(
    `/v1/housing-units/${unitId}/assessments`,
  );
}

export function getHousingAssessment(
  unitId: string,
  assessmentId: string,
): Promise<HousingAssessment> {
  return apiFetch<HousingAssessment>(
    `/v1/housing-units/${unitId}/assessments/${assessmentId}`,
  );
}

export function createHousingAssessment(
  unitId: string,
  input: CreateHousingAssessmentInput,
): Promise<HousingAssessment> {
  return apiFetch<HousingAssessment>(
    `/v1/housing-units/${unitId}/assessments`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
}

export function updateHousingAssessment(
  unitId: string,
  assessmentId: string,
  input: UpdateHousingAssessmentInput,
): Promise<HousingAssessment> {
  return apiFetch<HousingAssessment>(
    `/v1/housing-units/${unitId}/assessments/${assessmentId}`,
    {
      method: "PATCH",
      body: JSON.stringify(input),
    },
  );
}

export function deleteHousingAssessment(
  unitId: string,
  assessmentId: string,
): Promise<void> {
  return apiFetch<void>(
    `/v1/housing-units/${unitId}/assessments/${assessmentId}`,
    { method: "DELETE" },
  );
}
